import css from 'styled-jsx/css';

const styles = css.global`.sn-select {
  border: 1px solid #767676;
  border-radius: 5px;
  height: 40px;
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.sn-select select {
  border: none;
  width: 100%;
  padding: 0;
  margin: 0;
  outline: none;

  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #000;
  background: transparent;

  appearance: none;
  height: 100%;
  padding: 0 16px;
}

.sn-select .ic-container {
  display: flex;
  height: 20px;
  width: 20px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.sn-select select option {
  font: inherit;
  color: #000;
}

.sn-select select option:disabled {
  color: #767676 !important;
}

.sn-select~.input-error-text {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #f14c4c;
  margin-bottom: 8px;
}

@media (min-width: 992px) {
  .sn-select {
    height: 54px;
  }

  .sn-select .ic-container {
    display: flex;
    height: 24px;
    width: 24px;
  }

  .sn-select select {
    font-size: 18px;
    line-height: 26px;
  }

  .sn-select~.input-error-text {
    font-size: 18px;
    line-height: 26px;
  }
}`;

export default styles;